export default {
	terms: "Vilkår og betingelser",
	and: "Og",
	actions: {
		Submit: "Send",
		BackToLogin: "Tilbake til innlogging",
		Register: "Registrer",
		Logout: "Logg ut",
		Update: "Oppdater",
		Verify: "Bekreft",
		connect: "Koble til",
		Taptochange: "Trykk for å endre"
	},
	rules: {
		isRequired: "Påkrevd",
		require: "{0} er påkrevd",
		valid: "{0} er ikke et gyldig {0}",
		cannotContainBlankStrings: "{0} kan ikke inneholde tomme strenger"
	},
	options: {
		gender: ["Mann", "Kvinne"]
	}
};
